import ProductPageTemplate from "@/components/automacao/ProductPageTemplate";

const CrmPage = () => <ProductPageTemplate slug="crm" />;

export default CrmPage;
